import { COOKIE_KEYS } from '../constants/cookie-keys';
import { UserProfile } from '../types';

export function useUserProfile(): UserProfile {
  return JSON.parse(localStorage.getItem(COOKIE_KEYS.USER_PROFILE) ?? '{}');
}
